import { render, staticRenderFns } from "./OcupacionFinanciera.vue?vue&type=template&id=1ccf130d&"
import script from "./OcupacionFinanciera.vue?vue&type=script&lang=js&"
export * from "./OcupacionFinanciera.vue?vue&type=script&lang=js&"
import style0 from "./OcupacionFinanciera.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OcupacionFinanciera.vue"
export default component.exports